import { ICompileService, IPromise, IQService, Injectable } from "angular";
import { ColDef } from "../../../records/grids/columns/colDef";
import {
  ColumnDefinitionService,
  vsName as ColumnDefinitionServiceName,
} from "../../../records/grids/columns/columnDefinitionService";
import {
  ColumnDefinitionSetServiceProvider,
  vsProviderName as ColumnDefinitionSetServiceProviderName,
} from "../../../records/grids/columns/columnDefinitionSetService";
import {
  GridConfiguration,
  RecordGridViewServiceProvider,
  vsProviderName as RecordGridViewServiceProviderName,
} from "../../../records/views/recordGridView";
import { RecordDataSource } from "../../../records/grids";
import {
  GridSettingsService,
  IGridSettings,
  vsName as GridSettingsServiceName,
} from "../../../records/grids/settings/gridSettingsService";
import {
  ServerUtility,
  vsName as ServerUtilityName,
} from "../../../records/server/serverUtility";
import { FilterProvider } from "../../../records/grids/columns/filters/FilterProvider";
import { StateService } from "@uirouter/angularjs";

import { OptionsFilter } from "../../../records/grids/columns/filters/subFilters/OptionsFilter";

import { machineConfigurationObjectName } from "../../shared/names";
export { machineConfigurationObjectName as vsObjectName } from "../../shared/names";

machineConfigurationConfig.$inject = [
  RecordGridViewServiceProviderName,
  ColumnDefinitionSetServiceProviderName,
];
export function machineConfigurationConfig(
  recordGridViewServiceProvider: RecordGridViewServiceProvider,
  columnDefinitionSetServiceProvider: ColumnDefinitionSetServiceProvider
) {
  recordGridViewServiceProvider.addGridConfiguration(
    machineConfigurationObjectName,
    [
      "$q",
      ServerUtilityName,
      GridSettingsServiceName,
      "$state",
      ColumnDefinitionServiceName,
      "$compile",
      (
        $q: IQService,
        serverUtility: ServerUtility,
        gridSettingsService: GridSettingsService,
        $state: StateService
      ) =>
        new MachineGridConfiguration(
          $q,
          serverUtility,
          gridSettingsService,
          $state
        ),
    ]
  );

  columnDefinitionSetServiceProvider.addColumnDefinitionSet(
    machineConfigurationObjectName,
    [
      ColumnDefinitionServiceName,
      "$compile",
      (
        columnDefinitionService: ColumnDefinitionService,
        $compile: ICompileService
      ) => [
        columnDefinitionService.getNumberColDef({
          field: "Id",
          filter: new FilterProvider("Id", $compile)
            .defaultNumberFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getDateColDef({
          field: "OnFloorDate",
          header: "Original On Floor Date",
          filter: new FilterProvider("OnFloorDate", $compile)
            .defaultDateFilters()
            .getGridFilterFactory(),
        }),

        columnDefinitionService.getDateColDef({
          field: "Date",
          header: "Change Date",
          filter: new FilterProvider("Date", $compile)
            .defaultDateFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "SerialNumber",
          filter: new FilterProvider("SerialNumber", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "Status",
          filter: new FilterProvider("Status", $compile)
            .addFilter(
              "=",
              new OptionsFilter({
                displayName: "=",
                queryFieldNames: ["Status"],
                options: [
                  {
                    display: "Floor",
                    value: "Floor",
                  },
                  {
                    display: "Warehoused",
                    value: "Warehoused",
                  },
                  {
                    display: "Decommissioned",
                    value: "Decommissioned",
                  },
                ],
              })
            )
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineManufacturerName",
          header: "Manufacturer",
          filter: new FilterProvider("MachineManufacturerName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineCabinetTypeName",
          header: "Cabinet",
          filter: new FilterProvider("MachineCabinetTypeName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineStyleName",
          header: "Style",
          filter: new FilterProvider("MachineStyleName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "Section",
          filter: new FilterProvider("Section", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "Bank",
          filter: new FilterProvider("Bank", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "Slot",
          header: "Position",
          filter: new FilterProvider("Slot", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "WarehouseLocation",
          filter: new FilterProvider("WarehouseLocation", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "Location",
          filter: new FilterProvider("Location", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "ContractTypeName",
          header: "Contract Type",
          filter: new FilterProvider("ContractTypeName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "ConversionTypeName",
          header: "Conversion Type",
          filter: new FilterProvider("ConversionTypeName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getBooleanColDef({
          field: "MultiTheme",
          header: "Multi Theme?",
          filter: new FilterProvider("MultiTheme", $compile)
            .defaultBooleanFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getBooleanColDef({
          field: "MultiDenom",
          header: "Multi Denom?",
          filter: new FilterProvider("MultiDenom", $compile)
            .defaultBooleanFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getBooleanColDef({
          field: "Progressive",
          header: "Progressive?",
          filter: new FilterProvider("Progressive", $compile)
            .defaultBooleanFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
        columnDefinitionService.getStringColDef({
          field: "PrimaryGameName",
          header: "Game Name",
          filter: new FilterProvider("PrimaryGameName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
        }),
        columnDefinitionService.getStringColDef({
          field: "SoftwareId",
          filter: new FilterProvider("SoftwareId", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          header: "Software ID",
        }),
        columnDefinitionService.getStringColDef({
          field: "OsId",
          filter: new FilterProvider("OsId", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          header: "OS ID",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachineBillValidatorName",
          filter: new FilterProvider("MachineBillValidatorName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          header: "BV",
        }),
        columnDefinitionService.getStringColDef({
          field: "MachinePrinterName",
          filter: new FilterProvider("MachinePrinterName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          header: "Printer",
        }),
        columnDefinitionService.getStringColDef({
          field: "ContractTypeName",
          header: "Contract Type",
          filter: new FilterProvider("ContractTypeName", $compile)
            .defaultStringFilters()
            .getGridFilterFactory(),
          hide: true,
        }),
      ],
    ]
  );
}

class MachineGridConfiguration implements GridConfiguration {
  columns?: ColDef[];
  columnDefinitionSet?: string = machineConfigurationObjectName;
  onItemCommand?: Injectable<(...args: any[]) => IPromise<void>> = [
    () => {
      return this.$q.when();
    },
  ];
  gridDataSource?: RecordDataSource = new RecordDataSource(
    this.serverUtility,
    "/api/machines/MachineConfiguration"
  );
  defaultSort?: string = "PropertyName,Status,Location,SerialNumber";
  nameSingular?: string = "Machine Configuration";
  namePlural?: string = "Machine Configurations";
  showAddButton?: boolean = true;
  showAddButtonPermission?: string = "machineEdit";
  gridSelectionChanged?: Injectable<(...args: any[]) => void> = [
    () => {
      return this.$q.when();
    },
  ];
  showSelectButtons?: boolean = true;
  gridSettings?: IGridSettings;

  static $inject = ["$q", ServerUtilityName, GridSettingsServiceName, "$state"];
  constructor(
    private readonly $q: IQService,
    private readonly serverUtility: ServerUtility,
    gridSettingsService: GridSettingsService,
    private readonly $state: StateService
  ) {
    this.gridSettings = gridSettingsService.getGridSettings(
      Symbol("main.machines.grid")
    );
  }

  onAddNew = () => {
    return this.$state.go("^.add").then(() => {});
  };
}
